export default __webpack_public_path__ + "static/media/game2_bt.5df4c1d3.png";